export default __webpack_public_path__ + "images/P2.1752ed9.png";